<template>
  <span>
    <v-chip label pill class="chip-area left-area" :color="!selectValue ? 'primary' : '#FFF'" @click="changeBrowse">{{ falseText }}</v-chip>
    <v-chip label pill class="chip-area right-area" :color="selectValue ? 'primary' : '#FFF'" @click="changeEdit">{{ trueText }}</v-chip>
  </span>
</template>
<script>
import inputMixin from '@/mixins/inputMixins'
/**
 * @file DDv2 スイッチOnOffラジオボタン OnOffをチェックボックスで表現するには無理がある際に、本UIを利用できます
 * @namespace components
 * @interfaces Value
 * @notes CSS制御をするためにID , nameを固定で生成してます
 * @function OnOffを返す
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-radio/
 * @example
 *
  <dd-radio-switch-twoway
    v-show="isEditSwitchDisplay"
    class="ml-1"
    name="editmodeSwitch"
    :value="editMode"
    @click="onEditSwitchClick"
  />
*/
export default {
  name: 'DdRadioSwitchTwoWay',
  mixins: [inputMixin],
  props: {
    selectValue: {
      type: Boolean,
      default: false
    },
    /**
     * 内部識別名(必須)
     *
    name: {
      type: String,
      required: true
    },
    */
    falseText: {
      type: String,
      default: '閲覧'
    },
    trueText: {
      type: String,
      default: '編集'
    }
  },
  data: () => ({
  }),
  created () {
  },
  mounted () {
  },
  computed: {
    computedProps () {
      return {
        ...this.$props
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e)
      }
    }
    /*
    innerValue: {
      get () {
        return this.selectValue
      },
      set (value) {
        console.log('DrRadioWsitchTwoway:innerValue:' + value)
      }
    },
    GroupName () {
      // propsで受け取ったnameを加工する
      return 'ddradioswitch2way_' + this.name
    },
    processedNameA () {
      return 'ddradioswitch2wayon_' + this.name
    },
    processedNameB () {
      return 'ddradioswitch2wayoff_' + this.name
    }
    */
  },
  methods: {
    /*
    handleChange () {
      // isCheckedの値をvalueに反映する
      // console.log('DrRadioWsitchTwoway:handleChange:' + this.selectedOption)
      this.$emit('click')
    },
    */
    changeBrowse () {
      this.$emit('browse')
    },
    changeEdit () {
      this.$emit('edit')
    }
  }
}
</script>
<style scoped>
.chip-area {
  border: 1px solid var(--sub-action-color) !important;
  margin-top: 2px;
  padding: 4px 16px;
}
.left-area {
  border-radius: 6px 0 0 6px !important;
  border-right: 0px !important;
}
.right-area {
  border-radius: 0 6px 6px 0 !important;
  border-left: 0px !important;
}
</style>
